
import { FontAwesome5, MaterialIcons } from "@expo/vector-icons";

import { getIconItem, getIconItemPTW } from "../utils/itemCommonFunctions";
import { customApp } from "../config";
import { calcularVelocidadConexion } from "../utils/general";

import Spacer from "./base/Spacer";
import { Linking, View, } from "react-native";

import {
    Button as Button2,
    ButtonIcon, VStack, HStack,

} from "@gluestack-ui/themed";

import {
    AlertDialog, Button, Icon, Text
} from "native-base"
import { FunctionComponent, useRef } from "react";

export interface ModalIconInfoProps {
    showIconInfo: boolean;
    setShowIconInfo: Function;
    statusStore: any;
    isPTW?: boolean;
}
export const ModalIconInfo:FunctionComponent<ModalIconInfoProps> = ({ showIconInfo, setShowIconInfo, statusStore, isPTW = false }) => {
    const cancelRef = useRef();
    const setSpeedTest = (speed) => {
        statusStore.setFlashMessage("Velocidad de Conexion ".concat(speed, "Mbps"))
    }
    const WorkflowIconInfo = () => {
        return (
            <VStack >
                <View style={{ flexDirection: "row", flexWrap: "wrap", backgroundColor: "#226073", paddingHorizontal: 10 }}>
                    <Text color="white" bold={true} alignSelf="center">Probar velocidad de conexión</Text><Spacer />
                    <Button2 width={50} height={50} p="$1" variant="link" onPress={() => calcularVelocidadConexion(setSpeedTest, statusStore)} >
                        <ButtonIcon as={MaterialIcons} name="speed" fontWeight="$extrabold" size="xl" color="$red500" />
                    </Button2>
                </View>
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("draft")}
                    <Text ml="24px">Registro nuevo para ser completado.isPTW {isPTW}</Text>
                </HStack>
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("draft")}
                    {getIconItemPTW("pending")}
                    <Text width={"80%"} >Registro creado por otro usuario y que debo completar</Text>
                </HStack>
                {isPTW ? <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("draft")}
                    {getIconItemPTW("finished")}
                    <Text>Permiso aprobado, debo cerrar trabajo</Text>
                </HStack>:<></>}
                {isPTW ? <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("draft")}
                    {getIconItemPTW("closing")}
                    <Text>Permiso en cierre, debo cerrar mi control</Text>
                </HStack>:<></>}
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("closed")}
                    <Text width={"90%"} ml="24px">Registro completado listo para subirse al servidor.</Text>
                </HStack>
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("closed")}
                    {getIconItemPTW("pending")}
                    <Text width={"90%"}>Registro creado por otro usuario, que ya complete y debo subir al servidor</Text>
                </HStack>
                {isPTW ? <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("closed")}
                    {getIconItemPTW("closing")}
                    <Text>Permiso en cierre, debo subir mi control</Text>
                </HStack>:<></>}
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("sent")}
                    {getIconItemPTW("inprogress")}
                    <Text width={"90%"} >Registro en el que ya participe, y que continua su workflow</Text>
                </HStack>
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("sent")}
                    {getIconItemPTW("waiting")}
                    <Text width={"80%"} >Registro en el que debo participar, pero esta en una etapa previa</Text>
                </HStack>
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("sent")}
                    {getIconItemPTW("finished")}
                    <Text width={"90%"} >Registro con aprobación completa, pendiente fin de trabajo</Text>
                </HStack>

                {isPTW ? <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("sent")}
                    {getIconItemPTW("closing")}
                    <Text>Permiso en proceso de Cierre</Text>
                </HStack>:<></>}
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("sent")}
                    {getIconItemPTW("closed")}
                    <Text>{isPTW ? "Permiso cerrado" : "Registro cerrado"}</Text>
                </HStack>
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("sent")}
                    {getIconItemPTW("reject")}
                    <Text >Solicitud rechazada</Text>
                </HStack>
                <HStack borderBottomWidth={1} borderBottomColor={"gray.300"} py={1} alignItems="center" >
                    {getIconItem("sent")}
                    {getIconItemPTW("error")}
                    <Text >Error en la definición del comportamiento del Flujo de trabajo</Text>
                </HStack>

                
                 <View style={{ flexDirection: "row", flexWrap: "wrap", backgroundColor: "#000", padding: 10 }}>
                    <Text color="white" bold={true}>VISIBILIDAD</Text>
                </View>
                <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                    <Text>Los permisos de trabajo cerrados o rechazados permanecerán visibles durante las 24 horas posteriores a su gestión.
                         Pasado ese tiempo, deberán consultarse desde el módulo de gestión administrativa.</Text>
                </View>
                {customApp.packagename == "com.voolks.cgc" ? <>
                    <View style={{ flexDirection: "row", flexWrap: "wrap", backgroundColor: "#000", padding: 10 }}>
                        <Text color="white" bold={true}>INSTRUCTIVOS</Text>
                    </View>
                    <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon
                                onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/cgcpdt/CGC-PDT-Intro.mp4")} as={<FontAwesome5 name="file-pdf" />} size={"lg"} mr="2" color={"primary.400"} />
                            <Text>Instructivo Introductorio</Text>

                        </View>
                    <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon
                                onPress={() => Linking.openURL("https://s3.us-west-2.amazonaws.com/field.voolks.files/cgcpdt/CGC-PDT-CasoPractico.mp4")} as={<FontAwesome5 name="file-pdf" />} size={"lg"} mr="2" color={"primary.400"} />
                            <Text>Instructivo Caso Práctico</Text>

                        </View>
                </>:<></>}
                {customApp.packagename == "com.voolks.pampaptw" ? <>
                    <View style={{ flexDirection: "row", flexWrap: "wrap", backgroundColor: "#000", padding: 10 }}>
                        <Text color="white" bold={true}>INSTRUCTIVOS</Text>
                    </View>
                    <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
                        <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon
                                onPress={() => Linking.openURL("https://drive.google.com/file/d/1IqRKrADc9SsXKRSVxVsDCV0q6LTxRItQ/view?usp=drive_link")} as={<FontAwesome5 name="file-pdf" />} size={"lg"} mr="2" color={"primary.400"} />
                            <Text>Documentación </Text>

                        </View>
                        <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon onPress={() => Linking.openURL("https://drive.google.com/file/d/1RSbKyjnx3WyJUqhKuWGv_wDR82fcZvmy/view?usp=drive_link")}
                                as={<MaterialIcons name="video-library" />} size={"lg"} mr="2" color={"secondary.400"} />
                            <Text>Anexo A1 </Text>

                        </View>
                        <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon onPress={() => Linking.openURL("https://drive.google.com/file/d/19HqCPAnnEqwwc-p6tJ85imapRl-maxNv/view?usp=drive_link")}
                                as={<MaterialIcons name="video-library" />} size={"lg"} mr="2" color={"secondary.400"} />
                            <Text>Anexo A1 Cadena de aprobación </Text>

                        </View>
                        <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon onPress={() => Linking.openURL("https://drive.google.com/file/d/14eTY5WTNr1N3QAjL5GASaK5uJVSpnmwO/view?usp=drive_link")}
                                as={<MaterialIcons name="video-library" />} size={"lg"} mr="2" color={"secondary.400"} />
                            <Text>Anexo A1 - Habilitante </Text>

                        </View>
                        <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon onPress={() => Linking.openURL("https://drive.google.com/file/d/14eTY5WTNr1N3QAjL5GASaK5uJVSpnmwO/view?usp=drive_link")}
                                as={<MaterialIcons name="video-library" />} size={"lg"} mr="2" color={"secondary.400"} />
                            <Text>Anexo A1 - Cierre del Trabajo </Text>
                        </View>
                        <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon onPress={() => Linking.openURL("https://drive.google.com/file/d/14PTl4X_6SeYY35q8z9eNX94D02IYwxCN/view?usp=drive_link")}
                                as={<MaterialIcons name="video-library" />} size={"lg"} mr="2" color={"secondary.400"} />
                            <Text>Anexo A2 </Text>
                        </View>
                        <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon onPress={() => Linking.openURL("https://drive.google.com/file/d/1IZV7c2Mg0l_TtuKfciHpGaScE35XDiHa/view?usp=drive_link")}
                                as={<MaterialIcons name="video-library" />} size={"lg"} mr="2" color={"secondary.400"} />
                            <Text>Anexo A3 </Text>
                        </View>
                        <View style={{ flexDirection: "row", padding: 10, minWidth: "50%" }} >
                            <Icon onPress={() => Linking.openURL("https://drive.google.com/file/d/1tNYLKltjtscGLj2eehmb4IVqmjzQA_zF/view?usp=drive_link")}
                                as={<MaterialIcons name="video-library" />} size={"lg"} mr="2" color={"secondary.400"} />
                            <Text>Anexo A4 </Text>
                        </View>
                    </View> </> : <></>}
            </VStack>)
    }
    if(showIconInfo == false) return <></>;

    return (<AlertDialog leastDestructiveRef={cancelRef} isOpen={showIconInfo} onClose={() => setShowIconInfo(false)} size={"xl"}>
        <AlertDialog.Content>
            <AlertDialog.CloseButton />
            <AlertDialog.Header><Text>Descripción iconos</Text></AlertDialog.Header>
            <AlertDialog.Body >
                <WorkflowIconInfo />
            </AlertDialog.Body>
        </AlertDialog.Content>
    </AlertDialog>
    )
}

export interface ModalInfoProps {
    alertDialog: {title: string, message: string, action: Function}|undefined;
    setAlertDialog: Function;
}
export const ModalInfo: FunctionComponent<ModalInfoProps> = ({alertDialog, setAlertDialog}) => {
    const cancelRef = useRef();
    if(alertDialog == undefined ) return <></>;
    return (<AlertDialog leastDestructiveRef={cancelRef} isOpen={alertDialog != undefined} >
            <AlertDialog.Content>
              <AlertDialog.CloseButton />
              <AlertDialog.Header>{alertDialog?.title}</AlertDialog.Header>
              <AlertDialog.Body>{alertDialog?.message}</AlertDialog.Body>
              <AlertDialog.Footer>
                <Button ref={cancelRef} onPress={() => setAlertDialog(undefined)}>
                  Cancelar
                </Button>
                <Button colorScheme="red" ml={3} onPress={() => { alertDialog?.action(); setAlertDialog(undefined) }}>
                  Aceptar
                </Button>
              </AlertDialog.Footer>
            </AlertDialog.Content>
          </AlertDialog>)
}